/// <reference types="@angular/localize" />

import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

async function bootstrap() {
  // The MSAL redirect URI (/redirect) only runs the redirect bridge, never the full app:
  // booting the app there would start a second MSAL instance (guards, interceptor,
  // handleRedirectObservable) that races the bridge for the authentication response.
  const path = window.location.pathname;
  if (path === '/redirect' || path === '/redirect/') {
    const { RedirectComponent } = await import('./app/session/redirect/redirect.component');
    return bootstrapApplication(RedirectComponent);
  }

  const [{ AppComponent }, { appConfig }] = await Promise.all([
    import('./app/app.component'),
    import('./app/app.config'),
  ]);
  return bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]});
}

bootstrap().catch((err) => console.error(err));
